import style from "../lista.module.scss";
import { ITarefas } from "../../../types/tarefas";

interface Props extends ITarefas {
  selecionaTarefa: (tarefaSelecionada: ITarefas) => void;
}

export const ListaItem = ({
  tarefa,
  tempo,
  selecionado,
  completado,
  id,
  selecionaTarefa,
}: Props) => {
  return (
    <li
      className={`${style.item} ${selecionado ? style.itemSelecionado : ""} ${
        completado ? style.itemCompletado : ""
      }`}
      onClick={() =>
        !completado &&
        selecionaTarefa({
          tarefa,
          tempo,
          selecionado,
          completado,
          id,
        })
      }
    >
      <h3>{tarefa}</h3>
      <span>{tempo}</span>
      {completado && (
        <span className={style.concluido} area-label="tarefa concluida"></span>
      )}
    </li>
  );
};
